export enum Audio {
    WEBM = "audio/webm",
    OGA = "audio/ogg",
    ACC = "audio/aac",
    MP3 = "audio/mpeg"
}
